import { Component, h, ComponentInterface, Prop, Element, State, Method } from '@stencil/core';
import { getQueryStringValue, guid } from 'utils';


@Component({
  tag: 'kdx-site-search',
  styleUrl: 'kdx-site-search.scss',
  shadow: false
})
export class StSiteSearch implements ComponentInterface {

  @State() guid: string = guid();

  @Element() root: HTMLElement;
  @State() opened = false;
  @Prop() resultsUrl: string;
  @Prop() indexCatalogue: string;
  @Prop() wordsMode: string;
  @Prop() label: string;
  @Prop() placeholder: string;
  @Prop() searchId: string = `site-search`;

  public searchValue: string;

  componentDidRender() {
    const searchTermQs = getQueryStringValue('searchQuery');

    if (searchTermQs && searchTermQs != '') {
      const searchInput: HTMLInputElement = this.root.querySelector('input.form-control');
      searchInput.value = searchTermQs;
    }
  }

  handleFocus() {
    this.root.querySelector('.kdx-site-search').classList.add('has-focus');
  }

  handleBlur() {
    this.root.querySelector('.kdx-site-search').classList.remove('has-focus');
  }

  handleClick(event: Event) {
    event.preventDefault();
    (event.target as HTMLElement).closest('.input-group').querySelector('.form-control').classList.toggle('show');

    Array.from((event.target as HTMLElement).closest('.input-group').querySelectorAll('.kdx-show-mobile-search .svg-icon')).forEach((icon) => {
      icon.classList.toggle('d-none');
    });
  }

  searchSubmit(e) {
    e.preventDefault();
    var term = this.searchValue;

    if(typeof term !== 'undefined' && (term + '').trim() != ''){
      var qs = `?searchText=` + encodeURIComponent(term);
      window.location.href = this.resultsUrl + qs;
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey && !e.metaKey) {
      e.preventDefault();
      this.searchSubmit(e);
    }
  }

  setValue(e) {
    this.searchValue = e.target.value;
  }

  toggleSearch() {
    this.opened = this.opened ? false : true;

    //Close mobile nav too
    const toggle: HTMLElement = document.querySelector('.mobile-nav-toggle');
    const utils: HTMLElement = document.querySelector('.site-header__utils');
    const nav: HTMLElement = document.querySelector('.app-nav');

    if (!toggle || !nav || !utils) {
        return;
    }

    utils.classList.remove('open');
    nav.classList.remove('open');
    toggle.classList.remove('open');
    document.querySelector('body').classList.remove('menu-open');
  }

  @Method()
  async closeSearch() {
    this.opened = false;
  }

  render() {
    return (
      <div class={this.opened ? 'search is-open' : 'search'} tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter') { this.toggleSearch(); e.preventDefault(); } }}>
        <div class="search-form-inner">
          <form
            class='kdx-site-search site-search mt-2 mt-sm-1'
            onSubmit={(e) => { this.searchSubmit(e) }}>
            
              <input
                type="text"
                class="form-control"
                id={this.searchId}
                aria-label="Search"
                placeholder={this.placeholder}
                onFocus={() => { this.handleFocus() }}
                onBlur={() => { this.handleBlur() }}
                onKeyUp={(e) => { this.setValue(e) }}
                onKeyDown={(e) => {this.handleKeyDown(e)}} 
                />
              <button type="submit" class="input-group-text svg-icon" id="site-search-icon" aria-label="Submit Search">
                <kdx-icon icon="search-icon"></kdx-icon>
              </button>
          </form>
        </div>
        <div class="search-toggle" role="button" aria-label={this.opened ? "click to close site search" : "click to open site search"} tabIndex={0} onClick={() => {this.toggleSearch()}}>
          <span> </span> <kdx-icon icon="search-icon" class="open-icon"></kdx-icon> <kdx-icon icon="times" class="close-icon"></kdx-icon>
        </div>
        <div class="search-toggle-mobile" role="button" aria-label={this.opened ? "click to close site search" : "click to open site search"} tabIndex={0} onClick={() => { this.toggleSearch() }}>
          <div class="menu-icon">
            <span class="open-icon">
              <kdx-icon icon="search-icon"></kdx-icon>
            </span>
            <span class="close-icon">
              <kdx-icon icon="times"></kdx-icon>
            </span>
          </div>
          <span class="text"></span>
        </div>
      </div>
    );
  }
}